import React from 'react';

import {WidthItem} from 'src/components/width-item';

import {AvatarWrapped, Size} from '@pb/kit-component-avatar';
import {CheckBox} from '@pb/kit-component-checkbox';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group} from '@pb/kit-component-group';
import {Icons} from '@pb/kit-component-icon';

import type {DropDownItemRendererDataType} from '@pb/kit-component-dropdown-tree';
import type {UserSearchResult} from 'src/openapi/admin/models/UserSearchResult';

type Props = {
    checkboxProps: DropDownItemRendererDataType['checkboxProps'],
    data: DropDownItemRendererDataType['data'],
    user: UserSearchResult | undefined,
};

export const UserDropDownItem = ({checkboxProps, data, user}: Props) => (
    <CheckBox
        {...checkboxProps}
        label={(
            <Group alignItems="center">
                <AvatarWrapped
                    alt={data.id}
                    placeholder={Icons.USER}
                    size={Size.SMALL}
                    name={data.caption}
                />
                <WidthItem width={130}>
                    <EllipsisTextHint title={data.caption ?? ''}>
                        {data.caption}
                    </EllipsisTextHint>
                </WidthItem>
                {user?.email ? (
                    <EllipsisTextHint title={user.email} mix="disabled">
                        {user.email}
                    </EllipsisTextHint>
                ) : null}
            </Group>
        )}
    />
);
